export class IngestionPipeline {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "namespace",
            "baseName": "namespace",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableName",
            "baseName": "tableName",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceType",
            "baseName": "sourceType",
            "type": "IngestionSourceType",
            "format": ""
        },
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": ""
        },
        {
            "name": "s3SourceProperties",
            "baseName": "s3SourceProperties",
            "type": "S3SourceProperties",
            "format": ""
        },
        {
            "name": "gcsSourceProperties",
            "baseName": "gcsSourceProperties",
            "type": "GcsSourceProperties",
            "format": ""
        },
        {
            "name": "kafkaSourceProperties",
            "baseName": "kafkaSourceProperties",
            "type": "KafkaSourceProperties",
            "format": ""
        },
        {
            "name": "bucketFilesSourceProperties",
            "baseName": "bucketFilesSourceProperties",
            "type": "BucketFilesSourceProperties",
            "format": ""
        },
        {
            "name": "computeSize",
            "baseName": "computeSize",
            "type": "IngestionComputeSize",
            "format": ""
        },
        {
            "name": "catalogId",
            "baseName": "catalogId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "IngestionPipelineStatus",
            "format": ""
        },
        {
            "name": "failureMessage",
            "baseName": "failureMessage",
            "type": "string",
            "format": ""
        },
        {
            "name": "gcsRouterTopicId",
            "baseName": "gcsRouterTopicId",
            "type": "string",
            "format": ""
        },
        {
            "name": "maxPartitions",
            "baseName": "maxPartitions",
            "type": "number",
            "format": ""
        },
        {
            "name": "detectedPartitionCount",
            "baseName": "detectedPartitionCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return IngestionPipeline.attributeTypeMap;
    }
    constructor() {
    }
}
